import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isNumber } from 'lodash';
import { translate } from '../../../Services/translation';
import { showConfiguratorMoreProductInfoPopUp } from '../../../Actions/Configurator/Configurator.action';

const ProductSummaryModuleItem = ({ item, onQuantityChange }) => {
    const dispatch = useDispatch();
    const [quantity, setQuantity] = useState(item.confirmedQuantity || 0);
    const [calculatedPriceFormatted, setCalculatedPriceFormatted] = useState(0);
    const [isSelected, setIsSelected] = useState(item.confirmedQuantity > 0);

    useEffect(() => {
        const price = item.productCampaignPrice !== 0 ? item.productCampaignPrice: item.productPrice;
        const newCalculatedPrice = price ? price * quantity : 0;
        setCalculatedPriceFormatted(formatPrice(newCalculatedPrice));
    }, [quantity, item.productPrice, item.productCampaignPrice]);

    useEffect(() => {
        if (item.wholePallet && quantity % item.quantityPerPallet !== 0) {
            const timerId = setTimeout(() => {
                const palletQuantity = getClosestAmountOfPallets(quantity, item.quantityPerPallet);
                setQuantity(palletQuantity);
                setIsSelected(palletQuantity > 0);
                onQuantityChange(palletQuantity);
          }, 1000);
    
          return () => clearTimeout(timerId);
        } else {
            if (quantity > 0) {
                setIsSelected(true)
                onQuantityChange(quantity);
            } else {
                setIsSelected(false)
                onQuantityChange(quantity);
            }
        }
      }, [quantity]);

    const updateQuantityState = (newQuantity) => {
        setQuantity(newQuantity);
    };

    const subtractQuantity = () => {
        const newQuantity = subtract(quantity);
        updateQuantityState(newQuantity);
    }

    const addQuantity = () => {
        const newQuantity = add(quantity);
        updateQuantityState(newQuantity);
    }

    const subtract = (value) => {
        if (isNumber(value) && item.wholePallet) {
            if (value <= item.quantityPerPallet) {
                return item.quantityPerPallet;
            }
            return value - item.quantityPerPallet;
        }
        if (isNumber(value) && value > 0) {
            return value - 1;
        }
        return 0;
    }

    const add = (value) => {
        if (isNumber(value) && item.wholePallet) {
            return value + item.quantityPerPallet;
        }
        if (isNumber(value)) {
            return value + 1;
        }
        return 1;
    }

    const toggleItem = () => {
        const newSelectedState = !isSelected;
        setIsSelected(newSelectedState);
        const newQuantity = newSelectedState ? (quantity > 0 ? quantity : item.calculatedQuantity) : 0;
        setQuantity(newQuantity);
        onQuantityChange(newQuantity);
    };

    const getClosestAmountOfPallets = (quantity, quantityPerPallet) => {
        let closestAmountOfPallets = Math.ceil(quantity / quantityPerPallet) * quantityPerPallet;
        if (closestAmountOfPallets === 0) {
            closestAmountOfPallets = quantityPerPallet;
        }
        return closestAmountOfPallets;
    }

    const formatPrice = (value, separator = ' ') => {
        const stringValue = setNumberOfDecimals(value)
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };

    const setNumberOfDecimals = (value) => {
        let string = value.toString();
        let number = parseFloat(string);
        string = number.toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');
        return string;
    };

    return (
        <div className='product'>
            <a onClick={() => toggleItem()} className='product__item-link'>
                <div className={isSelected ? "product__selected" : "product__not-selected"}>
                        {item.campaignTag && item.campaignTag.isActive &&
                            <div className="campaign-tag" style={{ backgroundColor: item.campaignTag.backgroundColor, width: item.campaignTag.tagSize, boxShadow: item.campaignTag.shadow}}>
                                <div className="campaign-tag__text" style={{ color: item.campaignTag.textColor}} dangerouslySetInnerHTML={{__html: item.campaignTag.text}}>
                                </div>
                            </div>
                        }
                        <div className='product__image'>
                            <img
                                width="300"
                                height="300"
                                src={item.imageUrl}
                            />
                        </div>
                        <p className='product__name'>{item.name}</p>
                        {item.productCampaignPrice !== 0 ? (
                            <div>
                                <p className='configurator__price-campaign'>{item.productCampaignPrice ? `${formatPrice(item.productCampaignPrice)} ${item.currencyCode ? item.currencyCode : "kr"} / ${item.itemPriceUnit}` : 0}
                                <span className='configurator__old-price'>{item.productPrice ? `${formatPrice(item.productPrice)} ${item.currencyCode ? item.currencyCode : "kr"} / ${item.itemPriceUnit}` : 0}</span></p>
                            </div>
                        ) : (
                            <p className='product__price'>{item.productPrice ? `${formatPrice(item.productPrice)} ${item.currencyCode ? item.currencyCode : "kr"} / ${item.itemPriceUnit}` : 0}</p>
                        )}
                </div>                   
            </a>
            <div className={isSelected ? "product__info-link" : "product__info-link hidden"}>
                <a onClick={() => dispatch(showConfiguratorMoreProductInfoPopUp(item.productUrl))}>{translate("moreProductInformation")}</a>
            </div>
            <div className="product__card-styling-quantity">
                <div className='product__quantity-wrapper'>
                    <button className="product__quantity-button subtract-btn" onClick={() => subtractQuantity()}>
                        -
                    </button>
                    <div className="product__buy-quantity-container">
                        <input
                            type="text"
                            value={quantity}
                            className="product-detail__quantity-input form__input"
                            onChange={(event) => updateQuantityState(Number(event.target.value))}
                        />                    
                    </div>
                    <div className='product__unit'>{item.itemPriceUnit ? item.itemPriceUnit : "st"}</div>
                    <button className="product__quantity-button add-btn" onClick={() => addQuantity()}>
                        +
                    </button>
                </div>
                <div className="product__calculated-price">
                    {calculatedPriceFormatted} {item.currencyCode ? item.currencyCode : "kr"}
                </div>
            </div>
            {item.wholePallet &&
                <div className="product__whole-pallet">
                    {`${translate("product.wholePallet")} (${item.quantityPerPallet} ${item.itemPriceUnit}/${translate("product.pallet")})`}
                </div>
            }
        </div>
    );
}

export default ProductSummaryModuleItem;